<template>
    <v-container fill-height class="align-start">
        <v-row no-gutters class="align-self-center">
            <v-col>
                <v-row class="justify-space-between pa-4 absolute-top align-center" no-gutters>
                    <v-col>
                        <v-row class="align-center" no-gutters>
                            <v-col class="flex-grow-0">
                                <v-img
                                    alt="logo"
                                    src="/svg/logo-light-bg.svg"
                                    class="align-self-start mb-1"
                                    width="190"
                                    contain
                                ></v-img>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <tfa :userId="userId" @success="onTfaSuccess" @error="onTfaError" />
                <v-row align="center" justify="center">
                    <v-col class="form">
                        <v-row>
                            <v-col
                                class="d-flex justify-space-between align-center"
                            >
                                <a
                                    class="caption primary--text font-weight-bold pa-4"
                                    href="#"
                                >
                                    Home
                                </a>
                                <a
                                    href="https://www.kaoshinetwork.com/terms_of_service.html"
                                    class="caption primary--text font-weight-bold pa-4"
                                    target="_blank"
                                >
                                    Legal
                                </a>
                                <a
                                    href="https://www.kaoshinetwork.com/privacy_policy.html"
                                    target="_blank"
                                    class=" caption primary--text font-weight-bold pa-4"
                                >
                                    Privacy Policy
                                </a>
                            </v-col>
                        </v-row>
                        <p class="caption pb-6 mb-8 grey--text">
                            &copy; {{ year }} Kaoshi. All rights reserved.
                            Trademarks and brands are the property of their
                            respective owners.
                        </p>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import tfa from './components/tfa.vue';

    export default {
        components: {
          tfa,
        },
        data: function() {
            return {
                year: Vue.moment().year(),
            };
        },
        computed: {
          userId() {
            return vm.$store.state.user.id;
          },
        },
        methods: getMethods(),
        mounted: mounted
    };

    function mounted() {
    }

    function getMethods() {
        return {
            onTfaSuccess,
            onTfaError,
        };

        function onTfaSuccess(response) {

          // const { user, token } = response.data;
          // console.log('user', user);
          // console.log('token', token);
          //
          // vm.$store.commit('storeUser', user);
          // vm.$store.commit('storeAuthToken', token);
          // vm.$store.commit('setCurrentLoginTime');
          //
          // const { redirectTo } = vm.$route.query;
          // if(redirectTo) {
          //     console.log('redirecting to...', redirectTo);
          //     vm.$router.push(redirectTo);
          //     return true;
          // }
          //
          // console.log("sending to offers-list");
          // vm.$router.push({
          //     name:  'offers-list',
          // });
          // return false;

        }

        function onTfaError(error) {
            vm.$swal({
              type: 'error',
              title: 'Error',
              text: error,
            });
        }
    }

</script>
<style scoped>
    .slogan {
        color:#1a224e;
        font-size: .625rem!important;
        font-weight: 400;
        letter-spacing: .1666666667em!important;
        line-height: 1rem;
        font-family: Roboto,sans-serif!important;
        margin-top: .625rem;
        margin-left: 1rem;
        margin-bottom: 0;
        white-space: nowrap;
    }

    @media screen and (min-width: 600px) {
        .absolute-top {
            position: fixed;
            top: 0px;
            left: 50%;
            transform: translateX(-50%);
            max-width: 1300px;
            width: 90%;
        }
    }
</style>
